import { intlFormatDistance } from 'date-fns/intlFormatDistance';

function getLocale(locale?: string) {
  const defaultLocale = 'en-US';
  if (!locale) {
    if (typeof navigator !== 'undefined') {
      locale = navigator.language;
    } else {
      locale = defaultLocale;
    }
  }

  return locale;
}
export function formatDistance(timestamp: Date, localeParam?: string) {
  const locale = getLocale(localeParam);

  return intlFormatDistance(timestamp, new Date(), { locale, style: 'short' });
}

export function formatDate(date: Date, localeParam?: string) {
  const locale = getLocale(localeParam);

  return date.toLocaleDateString(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export function formatChartTick(value: Date | string | undefined, locale = 'en-US'): string {
  if (typeof value === 'string') return value;
  if (!(value instanceof Date)) return '';

  return value.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
}

export function formatChartLabel(value: Date | string | undefined, locale = 'en-US'): string {
  if (typeof value === 'string') return value;
  if (!(value instanceof Date)) return '';

  return value.toLocaleDateString(locale, { month: 'long', day: 'numeric', year: 'numeric' });
}
